<template>
  <v-card>
    <v-container class="py-5">
      <template v-if="is404Page">
        <v-row>
          <v-col class="text-center">
            <v-img
              class="mx-auto"
              alt="Page not found"
              max-width="120px"
              src="./ads-404-icon.svg"
            />
          </v-col>
        </v-row>
        <v-card-title class="justify-center">
          <h1>404 error</h1>
        </v-card-title>
        <v-card-title class="justify-center">
          <h2>
            {{
              title
                ? title
                : "The page you are looking for does not exist."
            }}
          </h2>
        </v-card-title>
        <v-card-text
          v-if="subtitle"
          class="text-center"
        >
          <h3>{{ subtitle }}</h3>
        </v-card-text>
        <v-row v-if="actions && Array.isArray(actions) && actions.length > 0">
          <v-col class="text-center">
            <template v-for="(action, i) in actions">
              <p :key="i">
                If you continue to experience this error please
                <a
                  :aria-label="action.text"
                  :href="action.attrs.href"
                  :target="action.attrs.target"
                  :rel="action.attrs.rel"
                >
                  {{ action.text }}
                </a>
              </p>
            </template>
          </v-col>
        </v-row>
      </template>
      <template v-else>
        <v-row>
          <v-col class="text-center">
            <v-icon
              class="icon"
              color="primary"
              size="120px"
            >
              mdi-alert-circle-outline
            </v-icon>
          </v-col>
        </v-row>
        <v-card-title class="justify-center">
          <h2>{{ title }}</h2>
        </v-card-title>
        <v-card-text
          v-if="subtitle"
          class="text-center"
        >
          {{ subtitle }}
        </v-card-text>
        <v-card-text
          v-if="errorCode || errorId"
          class="text-center"
        >
          <p
            v-if="errorCode"
            class="mb-0"
          >
            <strong>Error Code:</strong> {{ errorCode }}
          </p>
          <p v-if="errorId">
            <strong>Error ID:</strong> {{ errorId }}
          </p>
        </v-card-text>
        <v-row v-if="actions && Array.isArray(actions) && actions.length > 0">
          <v-col>
            <v-card-actions class="justify-center">
              <slot
                v-for="(action, i) in actions"
                :action="action"
                name="action-button"
              >
                <v-btn
                  :key="i"
                  :aria-label="action.text"
                  color="primary"
                  class="mx-5 pa-5"
                  v-bind="action.attrs"
                  v-on="action.on"
                >
                  {{ action.text }}
                </v-btn>
              </slot>
            </v-card-actions>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: 'ErrorPage',
  props: {
    is404Page: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'An error has occurred and we are trying to fix the problem.'
    },
    subtitle: {
      type: String,
      default: ''
    },
    errorCode: {
      type: String,
      default: null
    },
    errorId: {
      type: String,
      default: null
    },
    actions: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables.scss";

.icon {
  background-color: $ads-light-blue;
  border-radius: 50%;
  width: 185px;
  height: 185px;
}

h1 {
  color: $ads-navy-dark;
}

h2 {
  font-size: 24px;
}
</style>
